import React from 'react';
import { Alert, Collapse, FormHelperText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GroupNameNoticeProps } from '@modules/digital-signage/model/group-settings.model.ts';

const GroupNameNotice: React.FC<GroupNameNoticeProps> = ({
  isDefaultGroup,
  hasGroupName,
  addedDevicesCount
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Collapse in={isDefaultGroup && !hasGroupName} unmountOnExit>
        <FormHelperText className="opacity-100! transform-none! text-(--gray-2)!">
          {t('digital_signage_group_create_hint')}
        </FormHelperText>
      </Collapse>

      <Collapse
        in={isDefaultGroup && hasGroupName && addedDevicesCount > 0}
        unmountOnExit
      >
        <div className="pt-1.5">
          <Alert
            severity="warning"
            className="items-center! rounded-lg! py-0! px-2.5! [&_.MuiAlert-icon]:mr-2! [&_.MuiAlert-icon]:py-1.5! [&_.MuiAlert-icon_svg]:w-4! [&_.MuiAlert-icon_svg]:h-4! [&_.MuiAlert-message]:py-1.5!"
          >
            <Typography
              variant="caption"
              component="p"
              className="leading-4! text-(--dark-alpha-800)!"
            >
              {t('digital_signage_group_clear_name_warning', {
                count: addedDevicesCount
              })}
            </Typography>
          </Alert>
        </div>
      </Collapse>
    </>
  );
};

export default GroupNameNotice;
